import { Row, Col } from 'react-bootstrap';

export default function Receitas() {
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Receitas</small></p>
        </Col>
        <Col xs="12">
            <h1>Receitas</h1>
            <p>Para consultar as receitas da Alepe, você deverá acessar o Portal Tome Conta, disponível no link abaixo.</p>
        </Col>
        <Col xs="12" className="text-center mb-4">
            <a href="https://tomeconta.tcepe.tc.br/dados/ReceitasEstaduais!principal?unidadeJurisEstadual.codigo=010001" rel="noopener noreferrer" target="_blank"><img src="/img/tome-conta.jpeg" alt="Portal Tome Conta - Assembleia Legislativa do Estado de Pernambuco (ALEPE)" className="img-fluid"/></a>
        </Col>
    </Row>
}
